import * as Yup from "yup";
import { BrugereDTO } from "../../../interfaces/admin";
import { getPatchOperations } from "../../../util/form";

export const adminBrugerFormConfig = (
  brugerId?: string,
): FormConfig<BrugereDTO> => {
  const query = `brugere`;
  const queryWId = `${query}/${brugerId}`;
  return {
    title: "bruger",
    validationSchema: Yup.object({
      initialer: Yup.string().required("Initialer er påkrævet"),
      navn: Yup.string().required("Navn er påkrævet"),
      titel: Yup.string(),
      email: Yup.string().email("Ugyldigt email-format"),
      domainUserName: Yup.string().required("Domæne brugernavn er påkrævet"),
    }),
    form: [
      {
        component: "textinput",
        id: "initialer",
        initialValue: "",
        label: "Initialer",
      },
      {
        component: "textinput",
        id: "navn",
        initialValue: "",
        label: "Navn",
      },
      {
        component: "textinput",
        id: "titel",
        initialValue: "",
        label: "Titel",
      },
      {
        component: "textinput",
        id: "email",
        initialValue: "",
        label: "Email",
      },
      {
        component: "textinput",
        id: "domainUserName",
        initialValue: "",
        label: "Domæne brugernavn",
      },
    ],
    get: queryWId,
    post: (values) => {
      return {
        body: values,
        query: query,
      };
    },
    patch: (values) => {
      return {
        body: JSON.stringify(getPatchOperations(values)),
        query: queryWId,
      };
    },
  };
};
